export const AccordionData = [
  {
    title: "Do you offer standalone Branding or Web Design?",
    content:
      "Yes. While we recommend the Foundation Bundle for the best value, you can book them separately. Standalone Brand Identities start at $4,500 and Custom Web Builds (new sites or full revamps) start at $7,500. We mark these up because a-la-carte work requires more administrative heavy lifting than our bundled ‘Gold Standard’ process.",
  },
  {
    title:
      "Why is there a minimum commitment for the Growth and Partner plans?",
    content:
      "Building a high-performance asset isn't a sprint; it’s a marathon. The 12-month Growth Partnership ensures we don't just launch and leave, but actually optimise your site based on real data. For the 6-month Design Partner plan, the first 60 days typically focus on core architecture and branding, leaving the following 4 months for unlimited growth support, marketing assets, and refinements.",
  },
  {
    title: "What if I need to cancel my partnership early?",
    content:
      "We get it—business pivots happen. You can exit early by paying a 'Buyout Fee' of 50% of the remaining contract value. If you need to move your Bedrock-engineered site to your own hosting, we also charge a small one-time Migration Fee to ensure the technical handover is seamless and your site stays secure during the move.",
  },
  {
    title: "What does 'Unlimited Tasks' actually mean?",
    content:
      "It means you can fill your tasks queue with as many requests as you want. To maintain ‘Porsche-level’ quality, we work on one active task at a time. Once you approve a task, we move to the next. Most small tasks are out the door in 24–48 hours. Big stuff gets broken down into milestones so you always see progress.",
  },
  {
    title: "Who owns the website and content?",
    content:
      "You do. 100%. We avoid the common 'bloated' approach of stacking unstable plugins and drag-and-drop page builders that slow your business down. Instead, we build on Enterprise-Grade architecture (Bedrock/Composer). This means you own a clean, engineered asset that is faster, more secure, and easier for any professional developer to maintain.",
  },
  {
    title: "Do I still need to pay extra for hosting or plugins?",
    content:
      "If you’re on the Growth Partnership, no. We bundle premium managed hosting, security monitoring, and license fees into your monthly plan. If you choose the Foundation Build (Option A), you’ll handle those costs separately, but we’ll point you toward the best providers in Singapore to keep your site fast.",
  },
  {
    title: "How do I pay?",
    content:
      "For the Foundation Build, it’s 50% upfront and 50% at launch. For our Partnership plans, we bill monthly via automated invoice. We accept Bank Transfers, Stripe, and major Credit Cards. (Still no goats or chickens, unfortunately).",
  },
];
